class SjdColorSelector extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-sjd-color-option]'));
    this.output = this.querySelector('[data-sjd-selected-color]');
    this.whatsappTarget = document.querySelector('[data-sjd-whatsapp-role="hero-color-quote"]');
    this.hero = this.closest('.sjd-hero');

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.selectColor(button));
    });

    const firstButton = this.buttons[0];
    if (firstButton) this.selectColor(firstButton, false);
  }

  selectColor(button, focus = true) {
    const color = button.dataset.sjdColorOption || '';
    this.buttons.forEach((item) => {
      const isSelected = item === button;
      item.classList.toggle('is-selected', isSelected);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    if (this.output) this.output.textContent = color;
    this.updateHeroImage(button);
    this.updateWhatsApp(color);
    if (focus) button.focus();
  }

  updateHeroImage(button) {
    if (!this.hero || !button.dataset.sjdHeroImage) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;

    this.hero.style.setProperty('--sjd-hero-background', `url('${button.dataset.sjdHeroImage}')`);
  }

  updateWhatsApp(color) {
    if (!this.whatsappTarget || !color) return;

    const currentHref = this.whatsappTarget.getAttribute('href') || '';
    const baseHref = currentHref.split('?')[0];
    const isFrench = (document.documentElement.lang || '').toLowerCase().startsWith('fr');
    const baseMessage = this.whatsappTarget.dataset.sjdWhatsappMessage
      || (isFrench
        ? 'Bonjour, merci de m’envoyer votre catalogue et vos prix de gros pour les tissus africains.'
        : 'Hello, please send me your wholesale African lace price list.');
    const colorMessage = isFrench
      ? `Je suis intéressé(e) par les options de couleur ${color}.`
      : `I am interested in ${color} lace color options.`;
    const message = `${baseMessage} ${colorMessage}`;
    this.whatsappTarget.setAttribute('href', `${baseHref}?text=${encodeURIComponent(message)}`);
  }
}

if (!customElements.get('sjd-color-selector')) {
  customElements.define('sjd-color-selector', SjdColorSelector);
}
